import { Button, Modal } from "antd";
import React from "react";
import TextInfo from "../../../components/common/TextInfo/TextInfo";
import "react-datepicker/dist/react-datepicker.css";
import { DatePicker } from "antd";
import "moment/locale/id";
import locale from "antd/lib/locale-provider/id_ID";
import moment from "moment";

export default function ModalEdit({
  modalEdit,
  handleClose,
  submitting,
  onSubmitEdit,
  data,
  handleInputChange,
  errors,
  handleDate,
}) {
  return (
    <Modal
      title={"Ubah Data Nasabah"}
      visible={modalEdit}
      onCancel={handleClose}
      centered
      footer={[
        <Button
          disabled={submitting}
          key="back"
          onClick={handleClose}
          className="btn-modal btn-default"
          style={{ width: 100 }}
        >
          Kembali
        </Button>,
        <Button
          disabled={submitting}
          key="submit"
          type="primary"
          onClick={onSubmitEdit}
          className="btn-modal"
          style={{ width: 100 }}
        >
          Ubah
        </Button>,
      ]}
    >
      <div className="modal-form-content mt-3">
        <TextInfo
          title="Nama"
          value={data.customerName}
          type={"input"}
          id={"customerName"}
          handleChange={handleInputChange}
          error={errors?.customerName}
          isForm
        />
        <TextInfo
          title="NIK"
          value={data.nik}
          type={"input"}
          id={"nik"}
          handleChange={handleInputChange}
          error={errors?.nik}
          isForm
        />
        <TextInfo
          title="Jenis Kelamin"
          type={"radio"}
          id={"gender"}
          handleChange={handleInputChange}
          error={errors?.gender}
          value={data?.gender}
          radioData={[
            {
              label: "Laki-laki",
              value: "L",
            },
            {
              label: "Perempuan",
              value: "P",
            },
          ]}
          isForm
        />
        <>
          <div className="modal-title mb-4">
            <label>Tanggal Lahir</label>
          </div>
          <div className="modal-input align-items-start mb-4">
            <div className="d-flex modal-input">
              <span>: </span>
              <DatePicker
                locale={locale}
                format="DD MMMM YYYY"
                onChange={(date) => handleDate(date)}
                value={moment(data?.birthdate)}
              />
            </div>
            {errors?.birthdate ? (
              <span className="ml-2 small text-danger">
                {errors?.birthdate}
              </span>
            ) : null}
            {/* <ErrorMessage error={errors?.birthdate} /> */}
          </div>
        </>
        <TextInfo
          title="Provinsi"
          value={data.province}
          type={"input"}
          id={"province"}
          handleChange={handleInputChange}
          error={errors?.province}
          isForm
        />
        <TextInfo
          title="Kota"
          value={data.city}
          type={"input"}
          id={"city"}
          handleChange={handleInputChange}
          error={errors?.city}
          isForm
        />
        <TextInfo
          title="Kecamatan"
          value={data.subdistrict}
          type={"input"}
          id={"subdistrict"}
          handleChange={handleInputChange}
          error={errors?.subdistrict}
          isForm
        />
        <TextInfo
          title="Kelurahan"
          value={data.village}
          type={"input"}
          id={"village"}
          handleChange={handleInputChange}
          error={errors?.village}
          isForm
        />
        <TextInfo
          title="Detail Alamat"
          value={data.address}
          type={"input"}
          id={"address"}
          handleChange={handleInputChange}
          error={errors?.address}
          isForm
        />
      </div>
    </Modal>
  );
}
